// FO-124 (batch-24) — BTW-aangiftefrequentie per BV (gedeeld type + labels).
//
// Eén bron voor de UI-labels zodat de entiteiten-instellingen (<select>) en de
// frequentie-badge op het BTW-overzicht niet elk hun eigen strings hardcoden.
// De waarden spiegelen het Prisma-enum `BtwAangifteFrequentie` (MAAND/KWARTAAL/
// JAAR); de backoffice mag `@prisma/client` niet importeren, vandaar dit type.

export type BtwAangifteFrequentie = 'MAAND' | 'KWARTAAL' | 'JAAR'

/** Vaste keuzevolgorde voor de <select> in /instellingen/entiteiten. */
export const BTW_AANGIFTE_FREQUENTIES: ReadonlyArray<BtwAangifteFrequentie> = [
  'MAAND',
  'KWARTAAL',
  'JAAR',
]

/** Default voor een BV zonder ingestelde frequentie (zie schema-default). */
export const DEFAULT_BTW_AANGIFTE_FREQUENTIE: BtwAangifteFrequentie = 'KWARTAAL'

/** Korte keuze-labels (native select). */
export const BTW_AANGIFTE_FREQUENTIE_LABELS: Record<BtwAangifteFrequentie, string> = {
  MAAND: 'Maand',
  KWARTAAL: 'Kwartaal',
  JAAR: 'Jaar',
}

/** Badge-labels op het BTW-overzicht ("welke aangifte hoort hierbij"). */
export const BTW_AANGIFTE_FREQUENTIE_BADGE_LABELS: Record<BtwAangifteFrequentie, string> = {
  MAAND: 'Maandaangifte',
  KWARTAAL: 'Kwartaalaangifte',
  JAAR: 'Jaaraangifte',
}
